// Prime Zone "P" mark — uses the brand raster asset, cropped tight via background-position.

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_prime-wholesale-tech/artifacts/7dinrmjy_Artboard%201%20%281%29.png";

export default function Logo({ size = 40, className = "", glow = true }) {
  return (
    <span
      role="img"
      aria-label="Prime Zone FZCO"
      className={className}
      style={{
        display: "inline-block",
        width: size,
        height: size,
        backgroundImage: `url(${LOGO_URL})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "50% 50%",
        backgroundSize: "180% 180%",
        filter: glow ? "drop-shadow(0 0 12px rgba(122,92,255,0.55))" : "none",
      }}
    />
  );
}
